// extracted by mini-css-extract-plugin
export default {"applied-fliter-sentence-root":"AppliedFilterSentence_applied-fliter-sentence-root__cVhTH"};